import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Verification } from './../settings/verification';
import { Http, RequestOptions, Headers } from '@angular/http';
import { AuthService, User } from './../user/auth.service';
import { Subject } from 'rxjs/Subject';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { filter } from 'rxjs/operators';
import { RegistryService } from '../registry/registry.service';
import { ConfigurationService } from '../shared/configuration.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Registry } from '../registry/registry';
import { Settings } from '../settings/settings';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { Website } from '../website-builder/wedding';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { RegistryStateStore } from '../registry/registry.state.store';
declare var Stripe;
@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.scss']
})
export class PaymentPopupComponent implements OnInit, OnDestroy {
  fromStripe: boolean;
  conversionAlreadySent: boolean;
  conversionCompleted: boolean;
  currency: any;
  order_id: any;
  editedUrl: boolean = false;
  private unsubscribe$ = new Subject<void>();
  paidAmount: number = 0;
  currentPrice: any;
  isWebsite = false;
  total: any;
  tookSomethingOffline = false;
  step3formChange: boolean = false;
  registry: Registry;
  visibilityStatus: string;
  symbol: string;
  uuid: string;
  country: string;
  checkingRegistryName: boolean;
  urlConfirmed: boolean;
  settings: Settings;
  tier: string;
  isEu: boolean;
  paymentComplete = false;
  website: Website;
  registryNameChanges$ = new Subject<string>();
  invalidRegistryName: boolean;
  registryNotAvailableError: boolean;
  showVisibilitySettingsForBothProducts = false;
  noPaymentMethods: boolean = false;
  showPayment: boolean = true;
  user: User;
  displayToggles: {
    registry: {
      plus: boolean;
      unlimited: boolean
    }
    website: boolean,
    bundle: boolean,
    current: "registry" | "website" | "bundle" | ""
  }
  euCountries = [
    'AL',
    'AD',
    'AM',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FO',
    'FI',
    'FR',
    'GB',
    'GE',
    'GI',
    'GR',
    'HU',
    'HR',
    'IE',
    'IS',
    'IT',
    'LT',
    'LU',
    'LV',
    'MC',
    'MK',
    'MT',
    'NO',
    'NL',
    'PO',
    'PT',
    'RO',
    'RU',
    'SE',
    'SI',
    'SK',
    'TR',
    'UA',
    'VA'
  ];
  pricing: any =
  {
    AU: { country: "AU", website: 249, mid: 179, unlimited: 197, bundle: 399, micro: 149, },
    NZ: { country: "NZ", website: 249, mid: 179, unlimited: 149, bundle: 349, micro: 149, },
    US: { country: "US", website: 199, mid: 149, unlimited: 169, bundle: 349, micro: 119, },
    CA: { country: "CA", website: 199, mid: 149, unlimited: 177, bundle: 349, micro: 119, },
    GB: { country: "GB", website: 199, mid: 149, unlimited: 149, bundle: 349, micro: 119, },
    DE: { country: "DE", website: 199, mid: 149, unlimited: 117, bundle: 349, micro: 119, },
    DK: { country: "DK", website: 1199, mid: 899, unlimited: 887, bundle: 2150, micro: 749, },
  };

  mode: string;
  pricingTextLight: string;
  pricingText: string;
  type: string;
  processing: boolean;
  firstLaunchSaving: boolean;
  unpaid: boolean;
  websiteVisibilityStatus: string;
  passwordSaved: boolean;
  oldPrice: number;
  remainingHours: number;
  remainingMinutes: number;
  
  showCountdown: boolean = false;
  fromCreditCardSetup: boolean;

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,    
    private _analyticsService: AnalyticsService,
    private _authService: AuthService,
    private route: ActivatedRoute,    
    private _router: Router,
    private _websiteStateStore: WebsiteStateStore,    
    private router: Router
    
  ) {
    this.passwordSaved = false;
    this._registryFirebaseService.showMiniLaunchChanged.subscribe(([showPopup, isWebsite]) => {
      this.isWebsite = isWebsite;
 
    });

    this._authService.user.subscribe(user => {
      if (!user) {
        return;
      } else {
        this.user = user;
      }
    });


//     // Initial check
//     this.checkRoute();
// 
// if (this.route.snapshot.url.length >= 2 && this.route.snapshot.url[1].path === 'payment') {
//   this.showPayment = true;

// } else {
//   
//   this.showPayment = false;
// }
    this.calculateTimeRemaining();
    this.route.queryParams
      .subscribe(params => {

        if (params['fromStripe'] === 'true') {
          this.fromStripe = true;

        } else if (params['fromCreditCardSetup'] === 'true') {
          this.fromCreditCardSetup = true;
        } else {
          this.fromStripe = false;
        }
        if (params['currency'] && params['value']) {


          const conversionSent = localStorage.getItem('sent_conversion');
          this.conversionAlreadySent = conversionSent === 'true';
          this.conversionCompleted = true;
          this.currency = params['currency'];
          this.order_id = (<any>window).analytics.user().id();
          this.total = params['value'];
          if (!conversionSent) {
            this._analyticsService.trackGoogleAdsAndPinterestEvent('Order Completed', {
              order_id: (<any>window).analytics.user().id(),
              currency: params['currency'],
              value: params['value'],
              total: params['value'],
              subtotal: params['value'],
              revenue: params['value'],
              shipping: 0,
              tax: 0,
              products: [
                {
                  product_id: params['currency'] + params['value'],
                  sku: params['currency'] + params['value'],
                  name: 'Hitchd Honeymoon Registry',
                  price: params['value'],
                  quantity: 1,
                  category: 'Online',
                  url: 'https://www.hitchd.com'
                }
              ]
            });
            this.paymentComplete = true;
            localStorage.setItem('sent_conversion', 'true');
            this.fromStripe = false;
          }
        }
        if (params['launch'] === 'true') {
          this.paymentComplete = true;

        }
      });

  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  containsOnlyAlphanumeric(str: string): boolean {
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    return alphanumericRegex.test(str);
  }
  private checkRoute(): void {
    if (this.route.snapshot.url.length > 0 && this.route.snapshot.url[0].path === 'payment') {
      this.showPayment = true;
    } else {
      this.showPayment = false;
    }
  }
  ngOnInit() {
    this.isWebsite = location.href.toLowerCase().endsWith('/website/builder');
    document.title = 'Hitchd | Visibility';
    this.registry = this.route.snapshot.data.registry;

    // Listen for route changes to recalculate time
    this.router.events
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        if (event.url.includes('/registry/payment')) {
          this.calculateTimeRemaining();
        }
      });

    // Subscribe to registry updates and handle cleanup
    this._registryFirebaseService.registryByUserId(this.registry.userId)
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(registry => registry !== null && registry !== undefined)
      )
      .subscribe({
        next: (registry) => {
          this.registry = registry;
          if (this.registry) {
            this.country = this.registry.country;
            this.currency = this.registry.currency;
            this.setCurrentPrice();
            this.calculateTimeRemaining();
          }
        },
        error: (error) => {
          console.error('Error fetching registry:', error);
          this.showCountdown = false;
        }
      });

    // Initial calculation
    this.calculateTimeRemaining();

    //  this.gifts = this.route.snapshot.data.gifts;
    this.settings = this.route.snapshot.data.settings;
    this.website = this.route.snapshot.data.website;
    this.setVisibilityStatusRegistry();
    this.setVisibilityStatusWebsite();
    this.setVisualOptions()
    this._websiteStateStore.getState()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(state => {
      this.website = state.website;
      this.setVisibilityStatusRegistry();
      this.setVisibilityStatusWebsite();
      this.setVisualOptions()
    });

    if(this.settings){
    this.setCurrentPrice();
    this.determinePricingBoxesToDisplay();
    }

    ;
    

    if (!this.registry.hasCustomPaymentMethods && !this.settings.stripeAccountId) {
      this.noPaymentMethods = true;
    } 
    
    
    if (!this.registry.paid && !this.website.paid) {
      this.unpaid = true;
      this.setVisibilityStatusRegistry();
      this.setVisibilityStatusWebsite();
      // this.showPayment = true;
      // if (this.settings.weddingWebsiteEnabled) {
      //   return this._router.navigateByUrl('/visibility', {replaceUrl: true})
      // } else {
      //   return this._router.navigateByUrl('/visibility', {replaceUrl: true})
      // }


    }

    // Subscribe to the changes with a debounce of 1 second
    this.registryNameChanges$.pipe(debounceTime(1000)).subscribe(() => {
      // Perform the check here

      this.invalidRegistryName = false;
      if (!this.containsOnlyAlphanumeric(this.registry.registryName)) {
        this.invalidRegistryName = true;
      }

      this.registryNotAvailableError = false;
      //
      this.checkingRegistryName = false;
      this._registryFirebaseService
        .registryByName(this.registry.registryName.toLowerCase())
        .take(1)
        .subscribe(registry => {
          //
          if (registry) {
            this.registryNotAvailableError = true;
          }
        });

      //   }

    });
    





  }

  setCurrentPrice() {
    
    const ipCountry = this.country = this.registry.country;

    if (ipCountry) {
      this.country = ipCountry;
      this.setPricingFaq();
      this.setPricingFaqLight();
    } else {
      this.country = this.registry.country;
    }

    if (this.country == 'MX') {
      this.country = "US";
      this.currency = "USD";
      this.symbol = "$"
    }
    this.symbol = this.getSymbol(this.country);
    this.isEu = this.isCountryEu(this.country);
    this.currency = this.registry.currency;



    this.currentPrice = this.pricing[this.country];
    
    if (!this.currentPrice && this.isEu) {
      this.currentPrice = this.pricing['DE'];
    } else if (!this.currentPrice && !this.isEu) {
      this.currentPrice = this.pricing['US'];
      this.currency = "USD";
      this.symbol = "$"
    }

    // Calculate the old price (40% more than the current price)
    if (this.currentPrice) {
      this.oldPrice = this.currentPrice.unlimited * 1.4; // Increase by 40%
    }
  }

  debugReg(paid: boolean, live: boolean, webPaid: boolean, webLive: boolean, hasPaymentMethods: boolean) {
    this.registry.paid = paid;
    this.registry.isLive = live;
    this.registry.hasCustomPaymentMethods = hasPaymentMethods;
    this.website.paid = webPaid;
    this.website.isLive = webLive;
    this.noPaymentMethods = !hasPaymentMethods;
    this.setVisualOptions();
    //this.setVisibilityStatus();


  }


  debugWeb(paid: boolean, live: boolean) {
    this.website.paid = paid;
    this.website.isLive = live;
    // this.setRegistryVisibilityStatus();
    this.setVisualOptions();

  }
  back(){
    //check if there is something in history and if it is the same domain
    //if not go to /registry/publish/
    const previousUrl = document.referrer;

    if (previousUrl && new URL(previousUrl).hostname === window.location.hostname) {
      window.history.back();
    } else {
      this.router.navigate(['/registry/']);
    }
    
  }

  savePw(){
    this._registryFirebaseService.saveRegistry(this.registry);
    this.passwordSaved = true;
  }
  setVisualOptions() {

    if (this.website && this.website.paid && this.registry.paid) {
      this.showVisibilitySettingsForBothProducts = false;
    } else if (this.registry && this.website && this.registry.paid && this.website.paid && !this.website.paid && !this.registry.paid) {
      this.showVisibilitySettingsForBothProducts = false;
    } else if (this.website &&this.settings&& this.settings.weddingWebsiteEnabled != this.settings.registryEnabled) {
      this.showVisibilitySettingsForBothProducts = false;
    } else if (this.website &&this.settings&& this.settings.weddingWebsiteEnabled && this.settings.registryEnabled && this.website.paid != this.registry.paid) {
      this.showVisibilitySettingsForBothProducts = true;
    }

  }

  setVisibilityStatusWebsite(){

if(!this.website){
  return;
}
    if (this.website.isLive === undefined || !this.website.isLive  ) {
      this.firstLaunchSaving = true;
      this.websiteVisibilityStatus = 'private';
    } else if (this.website.isLive) {
      this.websiteVisibilityStatus = 'public';
    }
  }

  setVisibilityStatusRegistry(){

    if (this.registry.isLive === undefined) {
      this.firstLaunchSaving = true;
      this.visibilityStatus = 'private';
    } else if (this.registry.isLive && this.registry.paid) {
      this.visibilityStatus = 'public';
    } else if (!this.registry.isLive){
      this.visibilityStatus = 'private';
    }

  }
  // setVisibilityStatus() {
    
  //   if (this.paymentComplete) {
  //     this.visibilityStatus = 'private';
  //     this.step3formChange = true;
  //     return;
  //   }

  //   if (this.unpaid) {
  //     this.visibilityStatus = 'private';
  //     this.step3formChange = true;
  //     return;
  //   }

  //   if ((this.registry.isLive || (this.website && this.website.isLive)) && !this.registry.password) {
  //     this.visibilityStatus = 'public';
  //   } else if ((this.registry.isLive || (this.website && this.website.isLive)) && this.registry.password) {
  //     this.visibilityStatus = 'password';
  //   } else {
  //     this.visibilityStatus = 'private';
  //   }


  // }

  determinePricingBoxesToDisplay() {
    if (!this.currentPrice) {
      return;
    }

    if (!this.registry.paid && this.settings.registryEnabled && !this.settings.weddingWebsiteEnabled) {
      //reg only
      this.mode = 'pay';
      this.displayToggles = {
        registry: {
          plus: true,
          unlimited: true
        },
        website: false,
        bundle: true,
        current: ""

      }
    } else if (!this.website.paid && !this.settings.registryEnabled && this.settings.weddingWebsiteEnabled) {
      //web Only
      this.mode = 'pay';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: false
        },
        website: true,
        bundle: true,
        current: ""
      }
    } else if (!this.registry.paid && !this.website.paid && this.settings.registryEnabled && this.settings.weddingWebsiteEnabled) {
      //both
      this.mode = 'pay';
      this.displayToggles = {
        registry: {
          plus: true,
          unlimited: true
        },
        website: true,
        bundle: true,
        current: ""
      }

    } else if (this.registry.paid && !this.website.paid && this.settings.registryEnabled && !this.settings.weddingWebsiteEnabled) {
      this.mode = 'upgrade';


      if (this.registry.tier == 'medium') {
        this.paidAmount = this.currentPrice.mid;
      } else if (this.registry.tier == 'small') {
        this.paidAmount = this.currentPrice.micro;
      }
      else if (this.registry.tier == 'full') {
        this.paidAmount = this.currentPrice.unlimited;
      }

      //upgrade reg
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: this.registry.tier != 'full'
        },
        website: false,
        bundle: true,
        current: "registry"
      }
    } else if (this.website && this.website.paid && !this.registry.paid) {
      //upgrade web

      this.paidAmount = this.currentPrice.website;

      this.mode = 'upgrade';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: false
        },
        website: false,
        bundle: true,
        current: "website"
      }

    }
    else if ((this.website && !this.website.paid || !this.website) && this.registry.paid) {
      //upgrade web

      if (this.registry.tier == 'medium') {
        this.paidAmount = this.currentPrice.mid;
      } else if (this.registry.tier == 'small') {
        this.paidAmount = this.currentPrice.micro;
      }
      else if (this.registry.tier == 'full') {
        this.paidAmount = this.currentPrice.unlimited;
      }



      this.mode = 'upgrade';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: this.registry.tier != 'full',
        },
        website: false,
        bundle: true,
        current: "registry"
      }

    }



  }

  launchWeb() {

    this.website.isLive = true;

    this.setVisualOptions();
    this._websiteStateStore.updateWebsite(this.website);
    this.handleRedirect();
  }
  launchReg() {
    this.registry.isLive = true;
    this.setVisualOptions();
    this._registryFirebaseService.saveRegistry(this.registry);
    this.handleRedirect();
  }

  setRegistryVisibilityStatus() {
    this.registry.hasPassword = false;
    if(this.registry.password){
      this.registry.hasPassword = true;
    }
    if (this.visibilityStatus === 'private') {
      this.registry.isLive = false;
  
    }  else if (this.visibilityStatus === 'public') {
      if (this.registry.paid) {     
        this.registry.isLive = true;
      } 
    }
  }
  setWebsiteVisibilityStatus() {
   
    if (this.websiteVisibilityStatus === 'private') {
      this.website.isLive = false;
  
    }  else if (this.websiteVisibilityStatus === 'public') {
      this.website.isLive = true;
    }
  }

  updateRegistryName() {
    this.checkingRegistryName = true;
    this.urlConfirmed = false;
    this.editedUrl = true;
    this.registry.registryName = this.registry.registryName.toLowerCase();
    this.registryNameChanges$.next(this.registry.registryName);
  }




  handleRedirect() {

    if(this.tookSomethingOffline && (!this.website.isLive || !this.registry.isLive)){
      this.tookSomethingOffline = false;
      return;

    } else if (this.website.isLive || this.registry.isLive) {
      this._router.navigateByUrl("/overview/launched");
    }  
  }
  save() {

  
    if (this.registry.isLive === undefined) {
      this.firstLaunchSaving = true;
    }
       if (this.website.isLive === undefined) {
      this.firstLaunchSaving = true;
    }
    if (this.registry.password) {      
      this._registryFirebaseService.saveRegistry(this.registry);
    }
    this.setRegistryVisibilityStatus();
    this.setWebsiteVisibilityStatus();
    this.step3formChange = false;

    this.website.siteName = this.registry.registryName;
    this._websiteStateStore.updateWebsite(this.website);
  
    this._registryFirebaseService.saveRegistry(this.registry);
    if (this.paymentComplete) {
      this._router.navigateByUrl("/visibility")
      this.paymentComplete = false;
    } 
    this.handleRedirect();
  }



  getCurrency(countryCode) {
    if (countryCode === 'AU') {
      return 'AUD';
    } else if (countryCode === 'CA') {
      return 'CAD';
    } else if (countryCode === 'US') {
      return 'USD';
    } else if (countryCode === 'NZ') {
      return 'NZD';
    } else if (countryCode === 'GB') {
      return 'GBP';

    }
    // else if (countryCode === 'MX') {
    //   return 'MXN';
    // } 

    else if (countryCode === 'DK') {
      return 'DKK';


    } else if (this.isEu) {
      return 'EUR';
    } else {
      return 'USD';
    }
  }

  isCountryEu(country) {
    return this.euCountries.includes(country);
  }

  getSymbol(countryCode) {
    if (countryCode === 'AU') {
      return '$';
    } else if (countryCode === 'CA') {
      return '$';
    } else if (countryCode === 'US') {
      return '$';
    } else if (countryCode === 'NZ') {
      return '$';
    } else if (countryCode === 'GB') {
      return '£';
    } else if (countryCode === 'DK') {
      return 'Kr ';
    } else if (this.isEu) {
      return '€ ';
    } else {
      return '$';
    }
  }


  setPricingFaq() {
    this.pricingText = '';
    switch (this.country) {
      case 'AU': {
        this.pricingText =
          '1.7% + $0.30 for local Australian credit cards / +1.7% for international cards';
        break;
      }
      case 'MX': {
        this.pricingText =
          '3.6% + MXN$3 + IVA';
        break;
      }
      case 'DK': {
        this.pricingText =
          '1.4% + Kr 1.8 for all European credit cards / +1.5% for non-EU credit cards';
        break;
      }
      case 'US': {
        this.pricingText = '2.9% +$0.30 for US credit cards';
        break;
      }
      case 'CA': {
        this.pricingText =
          '2.9% + $0.30 for Canadian credit cards / +0.6% for international cards';
        break;
      }
      case 'NZ': {
        this.pricingText = '2.9% + $0.30';
        break;
      }
      case 'HK': {
        this.pricingText = '3.4% + $2.35';
        break;
      }
      case 'GB': {
        this.pricingText =
          '1.4% + £0.20 for UK and European credit cards and +1.5% for non-EU cards';
        break;
      }
      case 'JP': {
        this.pricingText = '3.6%';
        break;
      }
      case 'US': {
        this.pricingTextLight = '2.9% + $0.30 (+1% for Int. cards)';
        break;
      }
      case 'SG': {
        this.pricingText = '3.4% + $0.50';
        break;
      }
      default: {
        this.pricingText =
          '1.4% + €0.25 for European and UK credit cards and +1.5% for non-EU cards';
        break;
      }
    }
  }
  upgradeAccount(type: string) {
    (window as any).stripe = Stripe(environment.stripePublicKey, {

    });

    this.type = type;
    this.processing = true;
    return fetch(environment.firebase.clouldFunctionHost + '/createCheckoutSession', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        userAgent: navigator.userAgent,
        url: location.href,
        locale: 'auto',
        registryId: this.registry.id,
        source: this.registry.source,
        campaign: this.registry.campaign,
        partnershipId: this.registry.partnershipId,
        userId: this.registry.userId,
        uuid: this.uuid,
        country: this.country,
        isEu: this.isEu,
        email: this.user.email,
        type: this.type,
        fromStripe: this.fromStripe,
        fromCreditCardSetup: this.fromCreditCardSetup,
        // hoursLeft: this.daysLeft,
        isUpgrade: this.mode === 'upgrade',
        referalUserId: this.mode != 'upgrade' && this.registry.referalUserId ? this.registry.referalUserId : null,
        fromTier: this.registry.tier ? this.registry.tier : null,

      }),
    }).then((result) => {

      const reulst = result.json();
      reulst.then((x: any) => {
        const sessionId = x.sessionId;

        (window as any).stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (redirectResult) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
        //  return redirectResult.json();
      });


    }
    );
    //

  }

  setPricingFaqLight() {
    this.pricingTextLight = '';
    switch (this.country) {
      case 'AU': {
        this.pricingTextLight =
          '1.7% + $0.30 (+1.7% for Int. cards)';
        break;
      }
      case 'MX': {
        this.pricingTextLight =
          '3.6% + MSN$ 3';
        break;
      }
      case 'DK': {
        this.pricingTextLight =
          '1.4% + Kr 1.8 (+1.5% for non-EU cards)';
        break;
      }
      case 'US': {
        this.pricingTextLight = '2.9% + $0.30 (+1% for Int. cards)';
        break;
      }
      case 'CA': {
        this.pricingTextLight =
          '2.9% + $0.30 (+0.6% for Int. cards)';
        break;
      }
      case 'NZ': {
        this.pricingTextLight = '2.9% + $0.30';
        break;
      }
      case 'HK': {
        this.pricingTextLight = '3.4% + $2.35';
        break;
      }
      case 'GB': {
        this.pricingTextLight =
          '1.4% + £0.20 for UK/EU cards (+1.5% for Int. cards)';
        break;
      }
      case 'JP': {
        this.pricingTextLight = '3.6%';
        break;
      }
      case 'SG': {
        this.pricingTextLight = '3.4% + $0.50';
        break;
      }
      default: {
        this.pricingTextLight =
          '1.4% + €0.25 for EU/UK cards (+1.5% for non-EU cards)';
        break;
      }
    }
  }

  calculateTimeRemaining() {
    // Early return if no registry or no created date
    if (!this.registry || !this.registry.createdDate) {
      this.showCountdown = false;
      return;
    }
    
    try {
      // Convert from JSON date (milliseconds since epoch)
      const createdDate = new Date(this.registry.createdDate);
      
      // Validate the created date is valid
      if (isNaN(createdDate.getTime())) {
        this.showCountdown = false;
        return;
      }
      
      // Add 36 hours to creation date
      const endDate = new Date(createdDate.getTime() + (12 * 60 * 60 * 1000));
      const now = new Date();
      
      // Calculate difference
      const diffMs = endDate.getTime() - now.getTime();
      
      // If sale has ended, don't show countdown
      if (diffMs <= 0) {
        this.showCountdown = false;
        return;
      }
      
      // Convert to hours and minutes
      this.remainingHours = Math.floor(diffMs / (1000 * 60 * 60));
      this.remainingMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      this.showCountdown = true;
    } catch (error) {
      // If any error occurs during date calculation, hide the countdown
      this.showCountdown = false;
      console.error('Error calculating time remaining:', error);
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/payment-popup/payment-popup.component.ts